import { render, staticRenderFns } from "./Holidays.vue?vue&type=template&id=44b7c224&scoped=true"
import script from "./Holidays.vue?vue&type=script&lang=js"
export * from "./Holidays.vue?vue&type=script&lang=js"
import style0 from "./Holidays.vue?vue&type=style&index=0&id=44b7c224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b7c224",
  null
  
)

export default component.exports